import { LocationGroup } from '../../components/NewSearch/NewSearchLocations/types';
import { DISTRICT_ID, LOCATION_MODAL_TABS_STATS } from './constants';

export const getTabsTitlesFromLocationGroups = (
  locationGroups: LocationGroup[],
  chosenLocationIds: string[],
  townshipsCount: number
) => {
  return locationGroups.map(group => {
    const itemsCount = group.locations.reduce(
      (count, location) => {
        return chosenLocationIds.includes(location.id) ? count + 1 : count;
      },
      group.id === DISTRICT_ID ? townshipsCount : 0
    );

    return {
      name: group.name,
      label: group.name,
      itemsCount: itemsCount >= 0 ? itemsCount : undefined,
      stat: LOCATION_MODAL_TABS_STATS[group.id]
    };
  });
};
